export function normalizeOrganizationName(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}

export function scoreOrganizationMatch(target: string, candidate: string): number | null {
  if (!target || !candidate) {
    return null
  }
  if (!target.includes(candidate) && !candidate.includes(target)) {
    return null
  }
  return Math.min(target.length, candidate.length) / Math.max(target.length, candidate.length)
}
